import React, { Component } from 'react';
import { translate } from '~/decorators';
import PropTypes from 'prop-types';
import NoProfileImage from './images/no-profile-image.jpg';
import './HeaderCard.scss';

const HeaderCardExtra = ({ className = '', t, athlete }) => (
    <div className={`extra ${className}`}>
        {!!athlete.bib &&
            <div>
                <span className="label">
                    {t('Bib')}
                </span>

                {' '}

                <span className="text">
                    {athlete.bib}
                </span>
            </div>
        }

        {!!athlete.age &&
            <div>
                <span className="label">
                    {t('Age')}
                </span>

                {' '}

                <span className="text">
                    {athlete.age}
                </span>
            </div>
        }

        {!!athlete.stance &&
            <div>
                <span className="label">
                    {t('Stance')}
                </span>

                {' '}

                <span className="text">
                    {t(athlete.stance)}
                </span>
            </div>
        }
    </div>
);

class HeaderCardDetails extends Component {
    static propTypes = {
        colors: PropTypes.shape({
            color: PropTypes.string,
            scoreColor: PropTypes.string,
        }).isRequired
    };

    render() {
        const {
            className = '',
            athlete,
        } = this.props;

        return (
            <div className={`details ${className}`}>
                {athlete.additionalBio
                .map((item, i) => (
                    <div
                        key={`header_card_athlete_additional_bio_${athlete.externalId}_${i}`}
                    >
                        <span className="label">
                            {item.label}
                        </span>

                        {' '}

                        {item.value}
                    </div>
                ))}
            </div>
        );
    }
}

const PROFILES_URL = process.env.REACT_APP_PROFILES_URL;

export default
@translate(
    'home.header.header-card'
)
class HeaderCard extends Component {
    state = {
        detailsShow: false
    }

    static propTypes = {
        athletes: PropTypes.shape({
            expectedHeatId: PropTypes.any,
            byId: PropTypes.object,
            isLiveId: PropTypes.any
        }).isRequired,
        colors: PropTypes.shape({
            backgroundColor: PropTypes.string,
            color: PropTypes.string,
            locationColor: PropTypes.string,
            details: PropTypes.shape({
                color: PropTypes.string,
                scoreColor: PropTypes.string,
                sponsors: PropTypes.shape({
                    backgroundColor: PropTypes.string,
                    borderColor: PropTypes.string,
                }),
                more: PropTypes.shape({
                    backgroundColor: PropTypes.string,
                    borderColor: PropTypes.string,
                })
            })
        }).isRequired,
        eventId: PropTypes.string,
    }

    detailsToggle = () => {
        const { detailsShow } = this.state;

        this.setState({
            detailsShow: !detailsShow
        });
    }

    imageFallback = () => {
        this.image.src = NoProfileImage;
    }

    componentWillUnmount() {
        this.image = null;
    }

    render() {
        const {
            t,
            athletes,
            colors,
            eventId,
        } = this.props;

        const { detailsShow } = this.state;

        const toggleClassName = detailsShow
            ? 'fa-minus'
            : 'fa-plus';

        if (!athletes.isLiveId) {
            return (
                <div className="header-card not-available">
                    {t('No live information at this time')}
                </div>
            );
        }

        const athleteLive = athletes.byId[
            athletes.isLiveId
        ];

        return (
            <div className="header-card">
                <i
                    className={`toggle fa ${toggleClassName}`}
                    onClick={this.detailsToggle}
                    style={{display: (athleteLive.additionalBio.length === 0) ? 'none' : 'inline-block'}}
                />

                <div className="main">
                    <div className="image">
                        <div className="image-wrapper">
                            <img
                                ref={ref => this.image = ref}
                                alt={athleteLive.fullName}
                                src={`${PROFILES_URL}/${eventId}/${athleteLive.filename}`}
                                onError={this.imageFallback}
                            />
                        </div>
                    </div>

                    <div className="info">
                        <div className="names">
                            <div>{athleteLive.firstName}</div>
                            <div>{athleteLive.lastName}</div>
                        </div>

                        <div
                            className="location"
                            style={{ color: colors.locationColor }}
                        >
                            {athleteLive.nationality}, {athleteLive.homeTown}
                        </div>
                    </div>
                </div>

                <HeaderCardExtra
                    athlete={athleteLive}
                    t={t}
                />

                <HeaderCardDetails
                    className={
                        detailsShow
                            ? 'show'
                            : ''
                    }
                    t={t}
                    athlete={athleteLive}
                    colors={colors.details}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/header/HeaderCard.js